export const testAPI = (builder) => ({
  testAPI: builder.mutation({
    query: (body) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/api_integrations/test",
        method: "POST",
        body: body,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
    },
  }),
});
